<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      :max-width="dialogWidth"
      scrollable
    >
      <v-card v-if="item">
        <v-card-title class="pa-0">
          <v-toolbar
          >
            <v-btn
              icon
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ $t('app.pagos.single') }} {{ item.descripcion }}
            </v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-list
            two-line
            subheader
          >
            <v-subheader>{{ $t('app.general.information') }}</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.concepto.descripcion }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.conceptos_pago.single') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.divisa.symbol }}
                  {{ item.detalle.costo_final }}
                  {{ item.detalle.divisa.code }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.headers.final_price') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.divisa.symbol }}
                  {{ item.detalle.descuento }}
                  {{ item.detalle.divisa.code }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.headers.discount') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.divisa.symbol }}
                  {{ item.detalle.costo_neto }}
                  {{ item.detalle.divisa.code }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.headers.net_price') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.forma_pago.nombre }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.formas_pago.single') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.detalle.notas }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ $t('app.headers.notes') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: 'PagoDetail',
    data () {
      return {
        dialog: false,
        item: false,
      }
    },
    mounted() {
      EventBus.$on('pago-detail', (item) => {
        this.item = item
        this.dialog = true
      })
    },
  }
</script>

<style scoped>

</style>
